module.exports = __webpack_public_path__ + "img/unsatisfied.d25c3722.gif";